import { useMessageStore } from '@/stores/messageStore';
import { AxiosError } from 'axios';

const getErrorMessage = (error: unknown): string => {
  let message = '';
  if (error instanceof AxiosError) {
    message = error.response?.data.message;
  } else if (error instanceof Error) {
    message = error.message;
  } else {
    message = '';
  }
  return message;
};

export const useMessage = () => {
  const { showMessage } = useMessageStore();

  const handleErrorMessage = (
    error: unknown,
    title?: string,
    message?: string,
  ) => {
    const errorMessage =
      getErrorMessage(error) ||
      message ||
      '일시적인 문제가 생겼습니다. 잠시 후 다시 시도해주세요.';

    showMessage({
      title: title,
      message: errorMessage,
      type: 'alert',
    });
  };

  const showCustomMessage = (message: string, title?: string) => {
    showMessage({
      title: title,
      message: message,
      type: 'alert',
    });
  };

  const showConfirm = (
    message: string,
    onConfirm: () => void,
    onCancel?: () => void,
    title?: string,
  ) => {
    showMessage({
      title: title,
      message: message,
      type: 'confirm',
      onConfirm,
      onCancel,
    });
  };

  const showLoginRequired = (onConfirm: () => void) => {
    showMessage({
      title: '로그인이 필요합니다',
      message: '계속하려면 로그인해주세요.',
      type: 'login',
      onConfirm,
    });
  };

  return { handleErrorMessage, showCustomMessage, showConfirm, showLoginRequired };
};
